import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import { GynecologySidebar } from "../Layouts/GynecologySidebar";
import axios from "axios";
import $ from "jquery";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";

export class GPrePlanAnalysis extends Component {
  constructor(props) {
    super(props);

   

    ////
    const url = "";
    this.state = {
      PreviousDone: "",
      ExamType: "",
      ExamDate: "",
      Result: "",
      myParentTrigger: "",
      tablevaluesglobal: {},
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    //this.PrintWindow = this.PrintWindow.bind(this);
    this.modal = true;
  }

  componentDidMount() {
    $(".yesAnswer").click(function () {
      $(".prePlantable").show();
    });
    $(".noAnswer").click(function () {
      $(".prePlantable").hide();
    });
  }

  formatTableOutput(data) {
    let topobj = {};
    let tableobj = {};
    for (let i = 0; i < data.length; i++) {
      let trim = data[i];
      let trimobj = {};
      trimobj.ExamDate = data[i][0];
      trimobj.ExamType = data[i][1];
      trimobj.Result = data[i][2];
      tableobj[i] = trimobj;
      topobj.prepplan = tableobj;
    }
    this.state.tablevaluesglobal = topobj["prepplan"];
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  onTableChange(event) {}

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };

    event.preventDefault();

    // console.log(this.state.tablevaluesglobal[0]['ExamType'])
    for (var i = 0; i < Object.keys(this.state.tablevaluesglobal).length; i++) {
      console.log(this.state.tablevaluesglobal[i]["ExamType"]);
      var dict = {
        ExamType: this.state.tablevaluesglobal[i]["ExamType"],
        ExamDate: this.state.tablevaluesglobal[i]["ExamDate"],
        Result: this.state.tablevaluesglobal[i]["Result"],

        PreviousDone: this.state.PreviousDone,
      };
      console.log(dict);

      // : "",
      // : "",
      // Result:"",

      // finalpayload.PreviousObstetricUltrasound = PreviousObstetricUltrasound;
      // finalpayload.NumPreviousUltrasound = NumPreviousUltrasound;
      // finalpayload.ultrasound = this.state.tablevaluesglobal.ultrasound;
      // console.log(this.state)
      axios
        .post(this.api_url+""+localStorage.getItem('currentModule')+"/preplan/main", dict, {
          headers: headers,
        })
        .then((response) => {
          console.log(response);

          if (response.data == "No results found") {
            $(".noResultsFound").show();
            $(".alert-success").hide();
          } else {
            $(".noResultsFound").hide();
            $(".alert-success").show();

            $(response).each(function (index) {
              var individualResult =
                '<div className="card"> <div className="card-body">' +
                index.name +
                "</div> </div>";
              $(".alert-success").append(individualResult);
            });
            $(".alert-success").show();

            this.setState({ response: response });
            setTimeout(function () {
              window.location.href =
                "/gynecology/previous/pregancy/complication";
            }, 500);
            // console.log(response)alert-success
            //
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  handleTableChange(event) {
    console.log(event);
    this.setState({ myParentTrigger: this.state.myParentTrigger + "a" });
  }

  getTableValues(event) {
    console.log("entns");
    console.log(event);
    let tablevalues = this.formatTableOutput(event);
    console.log(tablevalues);
  }

  render() {
    const data = [["", "", ""]];
    const columns = ["Exam Date", "Exam Type", "Result"];
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    // const floatRight = {float:'right;'}
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const { PreviousDone, ExamType, ExamDate } = this.state;

    return (
      <div>
        <Headers />
        <GynecologySidebar></GynecologySidebar>

        <main className="content-container ">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-12 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Preplan Analysis executed
                  </p>
                </div>

                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Is Preplan Analysis executed?
                    </h6>
                    <select
                      className="form-control PreviousDone"
                      onChange={this.handleChange}
                      value={PreviousDone}
                      name="PreviousDone"
                      required
                    >
                      <optgroup label="pre plan Analysis Executed">
                        <option value="" selected disabled></option>
                        <option className="yesAnswer" value="yes">
                          Yes
                        </option>
                        <option className="noAnswer" value="no">
                          No
                        </option>
                      </optgroup>
                    </select>
                  </div>
                </div>
              </div>

              <div className="prePlantable mb-3" style={displayHidden}>
                <MDBCard>
                  <MDBCardHeader
                    tag="h3"
                    className="text-center font-weight-bold text-capitalise py-4"
                  >
                    Prepplan Analysis
                  </MDBCardHeader>
                  <MDBCardBody>
                    <MDBTableEditable
                      onChange={(value) => this.handleTableChange(value)}
                      getValue={(value) => this.getTableValues(value)}
                      myParentTrigger={this.state.myParentTrigger}
                      id="editablecard"
                      data={data}
                      columns={columns}
                      striped
                      bordered
                    />
                  </MDBCardBody>
                </MDBCard>
              </div>

              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>PrePlan Analysis Saved Successfully.
              </div>
              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default GPrePlanAnalysis;
